import { useSelector } from 'react-redux'
import { selectPermissions } from '../redux/authSelectors'
import { Permission } from '../types'

export default function usePermission(permission: Permission) {
  const userPermissions: Array<Permission> = useSelector(selectPermissions)
  return userPermissions.includes(permission)
}